import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY } from "archive/hooks/useArchiveIndexSetConfiguration";
const updateConfiguration = async (newConfiguration) => ArchiveArchiveIndexSet.updateIndexSetConfig(newConfiguration);
const useArchiveIndexSetConfigurationMutation = () => {
  const queryClient = useQueryClient();
  const update = useMutation({
    mutationFn: updateConfiguration,
    onError: (errorThrown) => {
      UserNotification.error(
        `Updating Archive Index Set Configuration failed with status: ${errorThrown}`,
        "Could not update Archive Index Set Configuration"
      );
    },
    onSuccess: () => {
      UserNotification.success("Archive Index Set Configuration has been successfully updated.", "Success!");
      queryClient.refetchQueries({ queryKey: [ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY], type: "active" });
    }
  });
  return {
    updateArchiveIndexSetConfigurationMutation: update.mutateAsync
  };
};
export default useArchiveIndexSetConfigurationMutation;
